import { render } from "./TableButton.vue?vue&type=template&id=5dcef196&scoped=true&ts=true"
import script from "./TableButton.vue?vue&type=script&lang=ts"
export * from "./TableButton.vue?vue&type=script&lang=ts"

import "./TableButton.vue?vue&type=style&index=0&id=5dcef196&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcef196"]])

export default __exports__